import {
  JRCT_PREFECTURES_OPTIONS,
  RECRUITMENT_STATUS_OPTIONS,
  STUDY_PHASES,
  ALLOCATION,
  INTERVENTIONAL_STUDY_MODEL,
  PRIMARY_PURPOSE,
  GENDER,
  NOT_SET_YES_NO,
  NOT_SET_APPLICABLE_NOT_APPLICABLE,
  NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT,
  NOT_SET_APPROVED_NOT_APPROVED,
  COUNTRIES,
  SHARE_IPD,
  PLANNED_ENROLLMENT_START_DATE_TYPE_JRCT,
} from "../enum/enum"

import { ageLimits } from "./commonSchemas"

import { study_identification, study_timeline, study_scope, study_description, study_ipd } from "./fieldSchemas"

import { RECRUITMENT_STATUS_MAPPING, PRIMARY_PURPOSE_MAPPING } from "../utils/registryOptionsMapping"

export const jrctDataSchema = {
  type_of_research: {
    type: "string",
    enum: [],
    default: "Clinical Trials, Post Marketing Surveillance",
    options: [
      {
        value: "Clinical Trials, Post Marketing Surveillance",
        label: "Clinical Trials, Post Marketing Surveillance",
        translations: {
          jp: "治験・製造販売後調査等",
        },
      },
      {
        value: "Other Clinical Research",
        label: "Other Clinical Research",
        translations: {
          jp: "その他の臨床研究",
        },
      },
    ],
  },
  study_identification: {
    clinical_trial_post_marketing_surveillance: {
      category_of_study: {
        type: "string",
        enum: [],
        options: [
          {
            value: "Company Sponsored Phase 1-3 Study",
            label: "Company Sponsored Phase 1-3 Study",
            translations: {
              jp: "企業治験",
            },
          },
          {
            value: "Investigator Sponsored Phase 1-3 Study",
            label: "Investigator Sponsored Phase 1-3 Study",
            translations: {
              jp: "医師主導治験",
            },
          },
          {
            value: "Phase 4 Study",
            label: "Phase 4 Study",
            translations: {
              jp: "製造販売後臨床試験",
            },
          },
          {
            value: "Post Marketing Surveillance",
            label: "Post Marketing Surveillance",
            translations: {
              jp: "使用成績調査",
            },
          },
          {
            value: "Others",
            label: "Others",
            translations: {
              jp: "その他",
            },
          },
        ],
      },
      subcategory_of_study: {
        type: "string",
        enum: [],
        default: "Main Clinical Study",
        options: [
          {
            value: "Main Clinical Study",
            label: "Main Clinical Study",
            translations: {
              jp: "主たる治験",
            },
          },
          {
            value: "Expanded Study",
            label: "Expanded Study",
            translations: {
              jp: "拡大治験",
            },
          },
          {
            value: "Others",
            label: "Others",
            translations: {
              jp: "主たる治験と拡大治験のいずれにも該当しない",
            },
          },
        ],
      },
    },
    other_clinical_research: {
      category_of_study: {
        type: "string",
        enum: [],
        options: [
          {
            value: "Non-specific clinical research",
            label: "Non-specific clinical research",
            translations: {
              jp: "非特定臨床研究 ",
            },
          },
          {
            value: "Observational Study",
            label: "Observational Study",
            translations: {
              jp: "観察研究",
            },
          },
          {
            value: "Surgery/Manipulation",
            label: "Surgery/Manipulation",
            translations: {
              jp: "手術・手技",
            },
          },
          {
            value: "Others",
            label: "Others",
            translations: {
              jp: "その他",
            },
          },
        ],
      },
    },
    shared: {
      jrct_number: {
        type: "string",
      },
      public_title_acronym: {
        type: "string",
      },
      registered_in_jrct_registry: {
        type: "string",
        enum: [],
        options: [
          {
            value: "Yes",
            label: "Yes",
            translations: {
              jp: "はい",
            },
          },
          {
            value: "No",
            label: "No",
            translations: {
              jp: "いいえ",
            },
          },
          {
            value: "NA",
            label: "NA",
            translations: {
              jp: "非該当",
            },
          },
        ],
      },
    },
    dependencies: {
      registered_in_jrct_registry: {
        oneOf: [
          {
            properties: {
              registered_in_jrct_registry: {
                type: "string",
                enum: ["Yes"],
              },
              summary_of_changes: {
                type: "object",
                properties: {
                  study_info_after_change: {
                    type: "string",
                  },
                  study_info_before_change: {
                    type: "string",
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  investigator_information: {
    type: "object",
    properties: {
      contact_for_scientific_queries: {
        type: "object",
        properties: {
          full_name: {
            type: "object",
            properties: {
              surname: {
                type: "string",
              },
              given_name: {
                type: "string",
              },
            },
          },
          erad_number: {
            type: "string",
          },
          affiliation: {
            type: "string",
          },
          department: {
            type: "string",
          },
          postal_code: {
            type: "string",
          },
          prefecture: {
            type: "string",
            enum: [],
            options: JRCT_PREFECTURES_OPTIONS,
          },
          address: {
            type: "string",
          },
          phone: {
            type: "string",
          },
          email: {
            type: "string",
          },
        },
      },
      contact_for_public_queries: {
        type: "object",
        properties: {
          full_name: {
            type: "object",
            properties: {
              surname: {
                type: "string",
              },
              given_name: {
                type: "string",
              },
            },
          },
          affiliation: {
            type: "string",
          },
          department: {
            type: "string",
          },
          postal_code: {
            type: "string",
          },
          prefecture: {
            type: "string",
            enum: [],
            options: JRCT_PREFECTURES_OPTIONS,
          },
          address: {
            type: "string",
          },
          phone: {
            type: "string",
          },
          fax: {
            type: "string",
          },
          email: {
            type: "string",
          },
        },
      },
      medical_institution_name: {
        type: "object",
        properties: {
          surname: {
            type: "string",
          },
          given_name: {
            type: "string",
          },
        },
      },
      administrator_permission: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      approval_date: {
        type: "string",
      },
      facilities_equipment_necessary_for_emergency_medical_care: {
        type: "string",
      },
    },
  },
  non_investigator_information: {
    clinical_trial_post_marketing_surveillance: {
      type: "object",
      properties: {
        data_management_agency_contacts: {
          type: "array",
          minItems: 1,
          items: {
            type: "object",
            properties: {
              organization_in_charge_of_data_management: {
                type: "string",
              },
              head_of_data_management: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                  post: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        monitoring_agency_contacts: {
          type: "array",
          minItems: 1,
          items: {
            type: "object",
            properties: {
              monitoring_agency: {
                type: "string",
              },
              person_in_charge_of_monitoring: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                  post: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        auditing_agency_contacts: {
          type: "array",
          minItems: 1,
          items: {
            type: "object",
            properties: {
              auditing_agency: {
                type: "string",
              },
              auditing_manager: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                  post: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        statistical_analysis_contact: {
          type: "object",
          properties: {
            organization_in_charge_of_statistical_analysis: {
              type: "string",
            },
            head_of_statistical_analysis: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
                post: {
                  type: "string",
                },
              },
            },
          },
        },
        organization_in_charge_of_research_and_development_planning_support_contact: {
          type: "object",
          properties: {
            organization_in_charge_of_research_and_development_planning_support: {
              type: "string",
            },
            research_and_development_planning_support_person: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
                post: {
                  type: "string",
                },
              },
            },
          },
        },
        coordination_and_management_agency_contact: {
          type: "object",
          properties: {
            coordination_and_management_agency: {
              type: "string",
            },
            coordination_and_management_personnel: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
                post: {
                  type: "string",
                },
              },
            },
          },
        },
        person_in_charge_of_other_research_contacts: {
          type: "array",
          minItems: 1,
          items: {
            type: "object",
            properties: {
              person_in_charge_of_other_research: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                  post: {
                    type: "string",
                  },
                  applicability_of_secondary_sponsor: {
                    type: "string",
                    enum: [],
                    options: NOT_SET_APPLICABLE_NOT_APPLICABLE,
                  },
                },
              },
            },
          },
        },
      },
    },
    other_clinical_research: {
      type: "object",
      properties: {
        data_management_agency_contacts: {
          type: "array",
          items: {
            type: "object",
            properties: {
              organization_in_charge_of_data_management: {
                type: "string",
              },
              head_of_data_management: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        monitoring_agency_contacts: {
          type: "array",
          items: {
            type: "object",
            properties: {
              monitoring_agency: {
                type: "string",
              },
              person_in_charge_of_monitoring: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        auditing_agency_contacts: {
          type: "array",
          items: {
            type: "object",
            properties: {
              auditing_agency: {
                type: "string",
              },
              auditing_manager: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                },
              },
            },
          },
        },
        statistical_analysis_contact: {
          type: "object",
          properties: {
            organization_in_charge_of_statistical_analysis: {
              type: "string",
            },
            head_of_statistical_analysis: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
              },
            },
          },
        },
        organization_in_charge_of_research_and_development_planning_support_contact: {
          type: "object",
          properties: {
            organization_in_charge_of_research_and_development_planning_support: {
              type: "string",
            },
            research_and_development_planning_support_person: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
              },
            },
          },
        },
        coordination_and_management_agency_contact: {
          type: "object",
          properties: {
            coordination_and_management_agency: {
              type: "string",
            },
            coordination_and_management_personnel: {
              type: "object",
              properties: {
                full_name: {
                  type: "object",
                  properties: {
                    surname: {
                      type: "string",
                    },
                    given_name: {
                      type: "string",
                    },
                  },
                },
                erad_number: {
                  type: "string",
                },
                affiliation: {
                  type: "string",
                },
              },
            },
          },
        },
        person_in_charge_of_other_research_contacts: {
          type: "array",
          items: {
            type: "object",
            properties: {
              person_in_charge_of_other_research: {
                type: "object",
                properties: {
                  full_name: {
                    type: "object",
                    properties: {
                      surname: {
                        type: "string",
                      },
                      given_name: {
                        type: "string",
                      },
                    },
                  },
                  erad_number: {
                    type: "string",
                  },
                  affiliation: {
                    type: "string",
                  },
                  applicability_of_secondary_sponsor: {
                    type: "string",
                    enum: [],
                    options: NOT_SET_APPLICABLE_NOT_APPLICABLE,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  information_on_multicenter_clinical_trials: {
    type: "object",
    properties: {
      applicability_of_multicenter: {
        type: "string",
        enum: [],
        options: NOT_SET_YES_NO,
        default: "Not set",
      },
    },
    dependencies: {
      applicability_of_multicenter: {
        oneOf: [
          {
            properties: {
              applicability_of_multicenter: {
                type: "string",
                enum: ["Yes"],
              },
              joint_research_institution_information: {
                type: "array",
                minItems: 1,
                items: {
                  type: "object",
                  properties: {
                    investigator_contact_informations: {
                      type: "object",
                      properties: {
                        full_name: {
                          type: "object",
                          properties: {
                            surname: {
                              type: "string",
                            },
                            given_name: {
                              type: "string",
                            },
                          },
                        },
                        erad_number: {
                          type: "string",
                        },
                        affiliation: {
                          type: "string",
                        },
                        department: {
                          type: "string",
                        },
                        postal_code: {
                          type: "string",
                        },
                        prefecture: {
                          type: "string",
                          enum: [],
                          options: JRCT_PREFECTURES_OPTIONS,
                        },
                        address: {
                          type: "string",
                        },
                        phone: {
                          type: "string",
                        },
                        email: {
                          type: "string",
                        },
                      },
                    },
                    research_contact_information: {
                      type: "object",
                      properties: {
                        full_name: {
                          type: "object",
                          properties: {
                            surname: {
                              type: "string",
                            },
                            given_name: {
                              type: "string",
                            },
                          },
                        },
                        institution: {
                          type: "string",
                        },
                        department: {
                          type: "string",
                        },
                        postal_code: {
                          type: "string",
                        },
                        prefecture: {
                          type: "string",
                          enum: [],
                          options: JRCT_PREFECTURES_OPTIONS,
                        },
                        address: {
                          type: "string",
                        },
                        phone: {
                          type: "string",
                        },
                        fax: {
                          type: "string",
                        },
                        email: {
                          type: "string",
                        },
                      },
                    },
                    medical_institution_name: {
                      type: "object",
                      properties: {
                        surname: {
                          type: "string",
                        },
                        given_name: {
                          type: "string",
                        },
                      },
                    },
                    administrator_permission: {
                      type: "string",
                      enum: [],
                      options: NOT_SET_YES_NO,
                      default: "Not set",
                    },
                    approval_date: {
                      type: "string",
                    },
                    facilities_equipment_necessary_for_emergency_medical_care: {
                      type: "string",
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  overview_of_pharmaceuticals: {
    type: "object",
    properties: {
      investigational_products: {
        type: "array",
        minItems: 1,
        items: {
          type: "object",
          properties: {
            intervention_type: {
              type: "string",
              enum: [],
              default: "Not set",
              options: [
                {
                  value: "Not set",
                  label: "Not set",
                  translations: {
                    jp: "未設定",
                  },
                },
                {
                  value: "Pharmaceuticals",
                  label: "Pharmaceuticals",
                  translations: {
                    jp: "医薬品",
                  },
                },
                {
                  value: "Medical equipment",
                  label: "Medical equipment",
                  translations: {
                    jp: "医療機器",
                  },
                },
                {
                  value: "Regenerative medicine products",
                  label: "Regenerative medicine products",
                  translations: {
                    jp: "再生医療等製品",
                  },
                },
              ],
            },
            approval_status: {
              type: "string",
              enum: [],
              default: "Not set",
              options: [
                {
                  value: "Not set",
                  label: "Not set",
                  translations: {
                    jp: "未設定",
                  },
                },
                {
                  value: "Unapproved",
                  label: "Unapproved",
                  translations: {
                    jp: "未承認",
                  },
                },
                {
                  value: "Off Label",
                  label: "Off Label",
                  translations: {
                    jp: "適応外",
                  },
                },
                {
                  value: "Approved",
                  label: "Approved",
                  translations: {
                    jp: "承認内",
                  },
                },
              ],
            },
            study_drug_provider: {
              type: "object",
              properties: {
                name: {
                  type: "string",
                },
                prefecture: {
                  type: "string",
                  enum: [],
                  options: JRCT_PREFECTURES_OPTIONS,
                },
                location: {
                  type: "string",
                },
              },
            },
          },
          dependencies: {
            intervention_type: {
              oneOf: [
                {
                  properties: {
                    intervention_type: {
                      type: "string",
                      enum: ["Pharmaceuticals"],
                    },
                    general_name: {
                      type: "object",
                      properties: {
                        pharmaceuticals: {
                          type: "object",
                          properties: {
                            generic_name: {
                              type: "string",
                            },
                            brand_name: {
                              type: "string",
                            },
                            approval_number: {
                              type: "string",
                            },
                          },
                        },
                      },
                    },
                  },
                },
                {
                  properties: {
                    intervention_type: {
                      type: "string",
                      enum: ["Regenerative medicine products"],
                    },
                    general_name: {
                      type: "object",
                      properties: {
                        regenerative_medicine_products: {
                          type: "object",
                          properties: {
                            classification: {
                              type: "string",
                            },
                            generic_name: {
                              type: "string",
                            },
                            approval_number: {
                              type: "string",
                            },
                          },
                        },
                      },
                    },
                  },
                },
                {
                  properties: {
                    intervention_type: {
                      type: "string",
                      enum: ["Medical equipment"],
                    },
                    general_name: {
                      type: "object",
                      properties: {
                        medical_equipment: {
                          type: "object",
                          properties: {
                            classification: {
                              type: "string",
                            },
                            generic_name: {
                              type: "string",
                            },
                            approval_number: {
                              type: "string",
                            },
                          },
                        },
                      },
                    },
                  },
                },
              ],
            },
          },
        },
      },
    },
  },
  study_timeline: {
    plan_sponsor_audit: {
      type: "string",
      enum: [],
      default: "Not set",
      options: NOT_SET_YES_NO,
    },
    recruitment: {
      type: "object",
      properties: {
        recruitment_status: {
          type: "string",
          enum: [],
          options: RECRUITMENT_STATUS_OPTIONS,
          valueMapping: RECRUITMENT_STATUS_MAPPING,
        },
        summary_results: {
          type: "string",
        },
      },
    },
    compensation_and_medical_care_in_the_event_of_health_damage: {
      type: "object",
      properties: {
        compensation_for_subjects: {
          type: "string",
          enum: [],
          default: "Not set",
          options: NOT_SET_YES_NO,
        },
        contents_of_compensation: {
          type: "object",
          properties: {
            with_insurance: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            non_insurance_coverage: {
              type: "string",
            },
          },
          dependencies: {
            with_insurance: {
              oneOf: [
                {
                  properties: {
                    with_insurance: {
                      type: "string",
                      enum: ["Yes"],
                    },
                    insurance_coverage: {
                      type: "string",
                    },
                  },
                },
              ],
            },
          },
        },
      },
    },
  },
  monetary_sponsor: {
    type: "object",
    properties: {
      primary_sponsors: {
        type: "array",
        minItems: 1,
        items: {
          type: "object",
          properties: {
            primary_sponsor_name: {
              type: "string",
            },
            monetary_support: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            contract_has_been_concluded: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            contract_date: {
              type: "string",
            },
            any_goods_support: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            contents_of_goods_supported: {
              type: "string",
            },
            any_resources_support: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            contents_of_resources_supported: {
              type: "string",
            },
          },
          dependencies: {
            monetary_support: {
              oneOf: [
                {
                  properties: {
                    monetary_support: {
                      type: "string",
                      enum: ["Yes"],
                    },
                    source_of_monetary_support: {
                      type: "string",
                    },
                  },
                },
              ],
            },
          },
        },
      },
      other_sponsors: {
        type: "array",
        minItems: 1,
        items: {
          type: "object",
          properties: {
            with_other_sponsor: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_YES_NO,
            },
            applicability_of_secondary_sponsor: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_APPLICABLE_NOT_APPLICABLE,
            },
            source_of_monetary_support: {
              type: "string",
            },
          },
        },
      },
    },
  },
  irb_information: {
    type: "object",
    properties: {
      irbs: {
        type: "array",
        minItems: 1,
        items: {
          type: "object",
          properties: {
            irb_name: {
              type: "string",
            },
            prefecture: {
              type: "string",
              enum: [],
              options: JRCT_PREFECTURES_OPTIONS,
            },
            address: {
              type: "string",
            },
            phone: {
              type: "string",
            },
            email: {
              type: "string",
            },
            irb_application_number: {
              type: "string",
            },
            irb_results: {
              type: "string",
              enum: [],
              default: "Not set",
              options: NOT_SET_APPROVED_NOT_APPROVED,
            },
          },
        },
      },
    },
  },
  study_ipd: {
    clinical_trial_post_marketing_surveillance: {
      notes: {
        multicenter_study: {
          type: "string",
          enum: [],
          default: "Not set",
          options: NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT,
        },
      },
    },
    other_clinical_research: {
      notes: {
        countries: {
          type: "string",
          enum: [],
          options: COUNTRIES.filter((country) => country !== "Japan"),
        },
        presence_combined_treatment_not_covered_by_insurance: {
          type: "string",
          enum: [],
          default: "Not set",
          options: NOT_SET_YES_NO,
        },
      },
    },
    shared: {
      contents_of_informed_consent_for_study: {
        type: "string",
      },
      other_registries: {
        type: "array",
        minItems: 1,
        items: {
          type: "object",
          properties: {
            other_registry_study_id: {
              type: "string",
            },
            issuing_authority: {
              type: "string",
            },
          },
        },
      },
      notes: {
        type: "object",
        properties: {
          research_under_guidelines_of_gene_therapy: {
            type: "string",
            enum: [],
            default: "Not set",
            options: NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT,
          },
          research_under_law_of_ensuring_biodiversity: {
            type: "string",
            enum: [],
            default: "Not set",
            options: NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT,
          },
          research_with_drugs_designed_as_biological_products: {
            type: "string",
            enum: [],
            default: "Not set",
            options: NOT_SET_APPLICABLE_NOT_APPLICABLE_ALT,
          },
        },
      },
      supplementary_information: {
        type: "array",
        maxItems: 3,
        items: {
          type: "object",
          properties: {
            others: {
              type: "string",
            },
          },
        },
      },
    },
  },
  study_description: {
    type: "object",
    properties: {
      brief_summary: {
        type: "string",
        maxLength: 5000,
      },
      start_date_of_enrollment: {
        type: "object",
        properties: {
          planned_enrollment_start_date_type: {
            type: "string",
            enum: [],
            options: PLANNED_ENROLLMENT_START_DATE_TYPE_JRCT,
          },

          actual_enrollment_start_date: {
            type: "string",
          },
        },
        dependencies: {
          planned_enrollment_start_date_type: {
            oneOf: [
              {
                properties: {
                  planned_enrollment_start_date_type: {
                    type: "string",
                    enum: ["2"],
                    options: PLANNED_ENROLLMENT_START_DATE_TYPE_JRCT,
                  },
                  planned_enrollment_start_date: {
                    type: "string",
                  },
                },
              },
            ],
          },
        },
      },
      study_start_date_in_japan: {
        type: "string",
      },
      inclusion_criteria: {
        type: "string",
      },
      exclusion_criteria: {
        type: "string",
      },
      discontinuation_criteria: {
        type: "string",
      },
      medical_conditions: {
        type: "array",
        items: {
          type: "object",
          properties: {
            condition: {
              type: "string",
            },
          },
        },
      },
      target_disease_code: {
        type: "string",
      },
      study_keywords: {
        type: "string",
        enum: null,
      },
      presence_of_interventions: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      interventions: {
        type: "string",
      },
      intervention_code: {
        type: "string",
      },
      intervention_keywords: {
        type: "string",
      },
      primary_outcome_measures: {
        type: "string",
      },
      secondary_outcome_measures: {
        type: "string",
      },
    },
  },
  study_scope: {
    type: "object",
    properties: {
      study_phase: {
        type: "string",
        enum: [],
        options: STUDY_PHASES,
      },
      enrollment_number: {
        type: "string",
      },
      allocation: {
        type: "string",
        enum: [],
        options: ALLOCATION,
      },
      jrct_masking: {
        type: "string",
        enum: [],
        options: [
          {
            value: "Open(Masking not used)",
            label: "Open(Masking not used)",
            translations: {
              jp: "非盲検",
            },
          },
          {
            value: "Double blind",
            label: "Double blind",
            translations: {
              jp: "二重盲検",
            },
          },
          {
            value: "Single blind",
            label: "Single blind",
            translations: {
              jp: "単盲検",
            },
          },
        ],
      },
      control: {
        type: "string",
        enum: [],
        options: [
          {
            value: "Placebo control",
            label: "Placebo control",
            translations: {
              jp: "プラセボ対照",
            },
          },
          {
            value: "Active control",
            label: "Active control",
            translations: {
              jp: "実薬（治療）対照",
            },
          },
          {
            value: "No treatment control/standard of care control",
            label: "No treatment control/standard of care control",
            translations: {
              jp: "無治療対照/標準治療対照",
            },
          },
          {
            value: "Uncontrolled",
            label: "Uncontrolled",
            translations: {
              jp: "非対照",
            },
          },
          {
            value: "Historical control",
            label: "Historical control",
            translations: {
              jp: "ヒストリカルコントロール",
            },
          },
          {
            value: "Dose comparison control",
            label: "Dose comparison control",
            translations: {
              jp: "用量比較",
            },
          },
        ],
      },
      interventional_study_model: {
        type: "string",
        enum: [],
        options: INTERVENTIONAL_STUDY_MODEL,
      },
      primary_purpose: {
        type: "string",
        enum: [],
        options: PRIMARY_PURPOSE,
        valueMapping: PRIMARY_PURPOSE_MAPPING,
      },
      placebo: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      blinding: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      randomization: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      non_insurance_combined_medical_expenses: {
        type: "string",
        enum: [],
        default: "Not set",
        options: NOT_SET_YES_NO,
      },
      countries_of_recruitment_except_japan: {
        type: "string",
        enum: [],
        options: COUNTRIES.filter((country) => country !== "Japan"),
      },
    },
  },
  study_eligibilty: {
    type: "object",
    properties: {
      age_limits: ageLimits,
      sex: {
        type: "string",
        enum: [],
        default: "Not set",
        options: GENDER,
      },
    },
  },
}

const sharedJrctDependencies = {
  int: {
    study_scope: {
      ...study_scope.interventional,
      properties: {
        ...jrctDataSchema.study_scope.properties,
        ...study_scope.interventional.properties,
      },
    },
  },
  obs: {
    study_scope: {
      ...study_scope.observational,
      properties: {
        ...jrctDataSchema.study_scope.properties,
        ...study_scope.observational.properties,
      },
    },
  },

  post_marketing: {
    study_ident: {
      ...study_identification,
      properties: {
        ...study_identification.properties,
        ...jrctDataSchema.study_identification.shared,
        ...jrctDataSchema.study_identification.clinical_trial_post_marketing_surveillance,
      },
      dependencies: jrctDataSchema.study_identification.dependencies,
    },
    study_ipd: {
      ...study_ipd.interventional_observational,
      properties: {
        ...jrctDataSchema.study_ipd.shared,
        notes: {
          ...jrctDataSchema.study_ipd.shared.notes,
          properties: {
            ...jrctDataSchema.study_ipd.shared.notes.properties,
            ...jrctDataSchema.study_ipd.clinical_trial_post_marketing_surveillance.notes,
          },
        },
      },
    },
  },
  other_research: {
    study_ident: {
      ...study_identification,
      properties: {
        ...study_identification.properties,
        ...jrctDataSchema.study_identification.shared,
        ...jrctDataSchema.study_identification.other_clinical_research,
      },
      dependencies: jrctDataSchema.study_identification.dependencies,
    },
    study_ipd: {
      ...study_ipd.interventional_observational,
      properties: {
        ...jrctDataSchema.study_ipd.shared,
        notes: {
          ...jrctDataSchema.study_ipd.shared.notes,
          properties: {
            ...jrctDataSchema.study_ipd.shared.notes.properties,
            ...jrctDataSchema.study_ipd.other_clinical_research.notes,
          },
        },
      },
    },
  },
  shared: {
    study_timeline: {
      ...study_timeline.interventional_observational,
      properties: {
        ...study_timeline.interventional_observational.properties,
        ...jrctDataSchema.study_timeline,
        recruitment: {
          ...study_timeline.interventional_observational.properties.recruitment,
          properties: {
            ...study_timeline.interventional_observational.properties.recruitment.properties,
            ...jrctDataSchema.study_timeline.recruitment.properties,
          },
        },
      },
    },
    study_description: {
      ...study_description,
      properties: {
        ...jrctDataSchema.study_description.properties,
        ...study_description.properties,
      },
    },
  },
}

export const jrctTypeOfResearchDependencies = {
  int: {
    post_marketing: {
      study_identification: sharedJrctDependencies.post_marketing.study_ident,
      non_investigator_information:
        jrctDataSchema.non_investigator_information.clinical_trial_post_marketing_surveillance,
      study_ipd: sharedJrctDependencies.post_marketing.study_ipd,
      study_timeline: sharedJrctDependencies.shared.study_timeline,
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: sharedJrctDependencies.int.study_scope,
    },
    other_research: {
      study_identification: sharedJrctDependencies.other_research.study_ident,
      non_investigator_information: jrctDataSchema.non_investigator_information.other_clinical_research,
      study_ipd: sharedJrctDependencies.other_research.study_ipd,
      study_timeline: sharedJrctDependencies.shared.study_timeline,
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: sharedJrctDependencies.int.study_scope,
    },
  },
  obs: {
    post_marketing: {
      study_identification: sharedJrctDependencies.post_marketing.study_ident,
      non_investigator_information:
        jrctDataSchema.non_investigator_information.clinical_trial_post_marketing_surveillance,
      study_ipd: sharedJrctDependencies.post_marketing.study_ipd,
      study_timeline: sharedJrctDependencies.shared.study_timeline,
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: sharedJrctDependencies.obs.study_scope,
    },
    other_research: {
      study_identification: sharedJrctDependencies.other_research.study_ident,
      non_investigator_information: jrctDataSchema.non_investigator_information.other_clinical_research,
      study_ipd: sharedJrctDependencies.other_research.study_ipd,
      study_timeline: sharedJrctDependencies.shared.study_timeline,
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: sharedJrctDependencies.obs.study_scope,
    },
  },
  expanded: {
    post_marketing: {
      study_identification: sharedJrctDependencies.post_marketing.study_ident,
      non_investigator_information:
        jrctDataSchema.non_investigator_information.clinical_trial_post_marketing_surveillance,
      study_ipd: {
        ...study_ipd.interventional_observational,
        properties: {
          ...jrctDataSchema.study_ipd.shared,
          plan_to_share_IPD: {
            type: "string",
            enum: [],
            options: SHARE_IPD,
          },
          plan_description: {
            type: "string",
            maxLength: 1000,
          },
          notes: {
            ...jrctDataSchema.study_ipd.shared.notes,
            properties: {
              ...jrctDataSchema.study_ipd.shared.notes.properties,
              ...jrctDataSchema.study_ipd.clinical_trial_post_marketing_surveillance.notes,
            },
          },
        },
      },
      study_timeline: {
        ...study_timeline.expanded_access,
        properties: {
          ...study_timeline.expanded_access.properties,
          ...jrctDataSchema.study_timeline,
          recruitment: {
            type: "object",
            properties: {
              recruitment_status: {
                type: "string",
                enum: [],
                options: RECRUITMENT_STATUS_OPTIONS,
                valueMapping: RECRUITMENT_STATUS_MAPPING,
              },
              ...jrctDataSchema.study_timeline.recruitment.properties,
            },
          },
        },
      },
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: {
        ...study_scope.expanded_access,
        properties: {
          ...jrctDataSchema.study_scope.properties,
          ...study_scope.expanded_access.properties,
        },
      },
    },
    other_research: {
      study_identification: sharedJrctDependencies.other_research.study_ident,
      non_investigator_information: jrctDataSchema.non_investigator_information.other_clinical_research,
      study_ipd: {
        ...study_ipd.interventional_observational,
        properties: {
          ...jrctDataSchema.study_ipd.shared,
          plan_to_share_IPD: {
            type: "string",
            enum: [],
            options: SHARE_IPD,
          },
          plan_description: {
            type: "string",
            maxLength: 1000,
          },
          notes: {
            ...jrctDataSchema.study_ipd.shared.notes,
            properties: {
              ...jrctDataSchema.study_ipd.shared.notes.properties,
              ...jrctDataSchema.study_ipd.other_clinical_research.notes,
            },
          },
        },
      },
      study_timeline: {
        ...study_timeline.expanded_access,
        properties: {
          ...study_timeline.expanded_access.properties,
          ...jrctDataSchema.study_timeline,
          recruitment: {
            type: "object",
            properties: {
              recruitment_status: {
                type: "string",
                enum: [],
                options: RECRUITMENT_STATUS_OPTIONS,
                valueMapping: RECRUITMENT_STATUS_MAPPING,
              },
              ...jrctDataSchema.study_timeline.recruitment.properties,
            },
          },
        },
      },
      study_description: sharedJrctDependencies.shared.study_description,
      study_scope: {
        ...study_scope.expanded_access,
        properties: {
          ...jrctDataSchema.study_scope.properties,
          ...study_scope.expanded_access.properties,
        },
      },
    },
  },
}
